import React from 'react'
import "./Footer.css"

function Footer() {
  return (
    <>
    <div className='footer'>
        <div className='author'>
        <p>Created by <a href="https://drive.google.com/file/d/1ujBHytxNCZNgJC8ymSZTmYvibvRST688/view" target="_blank" rel="noopener noreferrer">AKASH</a> with <i className='far fa-heart'></i>  "Email id : aksahkumar02032002@gmail.com"</p>
        </div>
        <div className=''>
        <p className='copyright'> <i className='far fa-copyright'></i> 2022 All rights reserved</p>
        </div>
    </div>
    </>
  )
}

export default Footer
